/* Copyright Verge Technologies 2018
 * @file about.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @descripton About page
 */

// Modules
import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CONTENT_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';


const About = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <div className="page-heading heading-about">About</div>

      <Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "about" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div>
                <div className="page-content">
                  <div className="content">
                    <h1>Our Vision</h1>
                    <p>
                      The Separations Vision lies in making South African Scientists and Laboratory
                      Technicians more successful by:
                    </p>
                    <p>
                      <ul>
                        <li>Supplying Spectacular Products</li>
                        <li>Providing Spectacular Technical Support</li>
                        <li>Delivering Spectacular Commercial Services</li>
                      </ul>
                    </p>
                    <hr />
                    <h1>Our Mission</h1>
                    <p>
                      To create raving fan customers, who delight in the fact that they can rely on receiving,
                      the finest products science has to offer; with support and commercial services that are
                      unparalleled in the market, for speed, efficiency, knowledge and kindness.
                    </p>
                    <hr />
                    <h1>Our Values</h1>
                    <p>
                      We believe in great and mutually beneficial relationships between Customers, Employees,
                      Suppliers and Shareholders.
                    </p>

                    <p>This requires the highest standards of ethics, which for us are:</p>
                    <p>
                      <ul>
                        <li>Honesty</li>
                        <li>Responsiveness</li>
                        <li>Reliability</li>
                        <li>Empathy</li>
                      </ul>
                    </p>
                    <hr />
                    <h1>Corporate Culture</h1>
                    <p>
                      We are committed to develop the full potential of all corporate team players and pledge
                      to respect their rights to success and self esteem. Our conduct will always be guided by
                      these principles:
                    </p>

                    <p>
                      Everyone’s work in our organization is worthwhile! We aim to motivate and explain why
                      everyone working for Separations is a positive contributor to the organization as well
                      as to our society as a whole.
                    </p>

                    <p>
                      {' '}
                      Every individual is in control of achieving their goals! Through training and sharing of
                      responsibilities Separations creates an environment, in which each individual has all
                      the tools and training to fully achieve and exceed their goals.
                    </p>

                    <p>
                      {' '}
                      We work as a team and motivate each other! All team players cheer each other on and
                      compliment sincere efforts, thus motivating each other to reach our worthy mutual goals.
                    </p>

                    <p>
                      {' '}
                      Directors and Managers work for their teams to achieve great results together and grow
                      the rewards for all employees and stake holders in an enthusiastic environment.
                    </p>
                  </div>
                </div>

                <div className="heading-container">
                  <h1>Services & Support</h1>
                  <hr />
                </div>

                <div className="support-container">
                  <ul>
                    <li>
                      <div className="content">
                        <div className="icon">
                          <img
                            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NS4yOTcgNjUuNDA2Ij4gIDxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwNGRhOSIgdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIzcHgiIGQ9Ik05Ny42ODIsNTUuMDU5bDQuNjE1LTEuNjQ4LTMuMDc2LTguNTdMOTQuNjA2LDQ2LjZhMjYuMDc1LDI2LjA3NSwwLDAsMC04LjEzLTguNzlsMi4wODgtNC41LTguMjQtMy44NDUtMi4wODgsNC41YTI1Ljg4OCwyNS44ODgsMCwwLDAtMTEuOTc2LS41NDlMNjQuNjExLDI4LjhsLTguNTcsMy4wNzYsMS42NDgsNC42MTVhMjYuMDc1LDI2LjA3NSwwLDAsMC04Ljc5LDguMTNsLTQuNS0yLjA4OC0zLjg0NSw4LjI0LDQuNSwyLjA4OEEyNS44ODgsMjUuODg4LDAsMCwwLDQ0LjUsNjQuODM3TDQwLDY2LjQ4NmwzLjA3Niw4LjU3LDQuNjE1LTEuNjQ4YTI2LjA3NSwyNi4wNzUsMCwwLDAsOC4xMyw4Ljc5bC0yLjA4OCw0LjUsOC4yNCwzLjg0NSwyLjA4OC00LjVhMjUuODg5LDI1Ljg4OSwwLDAsMCwxMS45NzYuNTQ5bDEuNjQ4LDQuNjE1LDguNTctMy4wNzYtMS42NDgtNC42MTVhMjYuMDc1LDI2LjA3NSwwLDAsMCw4Ljc5LTguMTNsNC41LDIuMDg4LDMuODQ1LTguMjQtNC41LTIuMDg4QTI3Ljk1NCwyNy45NTQsMCwwLDAsOTcuNjgyLDU1LjA1OVptLTIxLjEsMTkuNzc3QTE1Ljg1LDE1Ljg1LDAsMSwxLDg2LjAzNiw1NC41MSwxNS44ODYsMTUuODg2LDAsMCwxLDc2LjU4Nyw3NC44MzZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzguNSAtMjcuMjk5KSIvPjwvc3ZnPg=="
                            alt="Services"
                          />
                        </div>
                        <h3>Services</h3>
                      </div>
                      <div className="control">
                        <Link to="/services_support/services" className="button button-green">
                          View more
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="content">
                        <div className="icon wide">
                          <img
                            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4OS42ODcgNDIuNjYyIj4gIDxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwNGRhOSIgdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIzcHgiIGQ9Ik0xNTMuNCwzMjYuMjg1bDIxLjQyNC0yMC42NTVIMjAzLjk0djkuMTE5SDE5MC4yMDZ2OS43NzhoMjQuNzIxTDIzMy4wNTUsMzA1LjNsNy4wMzIsNi45MjItMjQuMDYxLDI0LjA2MUgxODAuMzE4bC0xMi4yLDguNjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUxLjkgLTMwMy44KSIvPjwvc3ZnPg=="
                            alt="Workflows"
                          />
                        </div>
                        <h3>Workflows</h3>
                      </div>
                      <div className="control">
                        <Link to="/services_support/applications" className="button button-green">
                          View more
                        </Link>
                      </div>
                    </li>
                  </ul>
                </div>
                </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
<div dangerouslySetInnerHTML={{__html: data.getContent.body}} />
            </div>
          );
        }}
      </Query>


          
      <Footer />
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/about/about.page.js